const styles = {
  paper: {
    padding: 2,
    backgroundColor: '#272727',
    boxShadow: 'none',
    opacity: '0.9!important',
    color: 'secondary.contrastText',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  line0: {
    marginBottom: 3,
    textAlign: 'center',
    color: (theme) => `${theme.palette.text.white}!important`,
  },

  line1: {
    marginBottom: 2,
    textAlign: 'center',
    color: (theme) => `${theme.palette.text.white}!important`,
  },

  line2: {
    textAlign: 'center',
    height: 100,
    color: (theme) => `${theme.palette.text.white}!important`,
  },
  line3: {
    textAlign: 'center',
    height: 100,
    color: (theme) => `${theme.palette.primary.main}!important`,
  },
}

export default styles
